import { useEffect, useSyncExternalStore } from "react";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import Wordmark from "../Wordmark/Wordmark";
import {
  isLandingMenuOpen,
  setLandingMenuOpen,
  subscribeLandingMenu,
} from "./landingMenu";
import "./LandingHeader.css";

const DESTINATIONS = [
  { label: "Planos", href: "#planos" },
  { label: "Como funciona", href: "#como-funciona" },
  { label: "Dúvidas", href: "#duvidas" },
  { label: "Contato", to: "/contato" },
  { label: "Entrar", to: "/login" },
] as const;

function renderLandingHeaderLinks() {
  return DESTINATIONS.map((item) => {
    const onClick = () => setLandingMenuOpen(false);
    if ("to" in item) {
      return (
        <Link
          key={item.to}
          to={item.to}
          className="landing-header__link"
          onClick={onClick}
        >
          {item.label}
        </Link>
      );
    }
    return (
      <a
        key={item.href}
        href={item.href}
        className="landing-header__link"
        onClick={onClick}
      >
        {item.label}
      </a>
    );
  });
}

export default function LandingHeader() {
  const open = useSyncExternalStore(
    subscribeLandingMenu,
    isLandingMenuOpen,
    () => false,
  );

  useEffect(() => {
    return () => {
      setLandingMenuOpen(false);
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }
    const media = window.matchMedia("(min-width: 768px)");
    // The panel is display:none from 768px up, but an open flag would still
    // take the next Escape and leave the news strip up.
    const closeWhenWide = () => {
      if (media.matches) setLandingMenuOpen(false);
    };
    closeWhenWide();
    media.addEventListener("change", closeWhenWide);
    return () => media.removeEventListener("change", closeWhenWide);
  }, []);

  return (
    <header
      id="landing-header"
      className="landing-header"
      data-menu-open={open ? "true" : "false"}
    >
      <div className="landing-header__brand">
        <Wordmark width={190} variant="light" to="/" label="Acertei Questões" />
        <div className="landing-header__spacer" />
      </div>
      <nav className="landing-header__nav" aria-label="Navegação">
        {renderLandingHeaderLinks()}
      </nav>
      <button
        type="button"
        className="landing-header__menu"
        aria-label="Abrir menu"
        aria-expanded={open}
        aria-controls="menu-mobile"
        onClick={() => setLandingMenuOpen(!open)}
      >
        <Menu size={24} aria-hidden="true" />
      </button>
      <nav
        id="menu-mobile"
        className="landing-header__panel"
        aria-label="Navegação"
      >
        {renderLandingHeaderLinks()}
      </nav>
    </header>
  );
}
